import React from 'react';
import RecordPage from './RecordPage';
import SummaryPage from './SummaryPage';
import IndexPane from './IndexPane';
import { HeartFillIcon, SquareIcon, FillSquare, ArrowLeftShort, ArrowRightShort } from './Icons';
import { Badge } from 'react-bootstrap';

import './App.css';

function Viewer(props) {
    const [getStatus, setStatus] = React.useState();
    const [getSelection, setSelection] = React.useState("|**|");
    const [getRecords, setRecords] = React.useState([]);
    const [getSearchRecords, setSearchRecords] = React.useState([]);
    const [getSearchText, setSearchText] = React.useState("");
    const [getFavorite, setFavorite] = React.useState({});
    const [getColSize, setColSize] = React.useState(2);
    const [getRefresh, setRefresh] = React.useState(0);

    const onKeyDown = (e) => {
        if (e.keyCode === 13) {
            let records = [];

            let text = getSearchText;
            if (text.length > 0) {
                if (text.indexOf(':') === -1) {
                    text = "Message:" + text;
                }

                let results = [];

                try {
                    results = props.Index.LunrIndex.search(text);
                    setStatus("[" + text + "] found " + results.length + " items.");
                }
                catch (e) {
                    console.log("Search failed", e);
                    setStatus("[" + text + "] FAILED: " + e.message);
                }

                for (let n in results) {
                    records.push(results[n].ref);
                }
            }

            setRecords(records);
            setSearchRecords(records);
            setSelection("Search|**|None");
        }
    }

    const onChange = (e) => {
        setSearchText(e.target.value);
    }

    const clickSearchPane = (e) => {
        let text = getSearchText;
        if (text.indexOf(':') === -1) {
            text = "Message:" + text;
        }

        setRecords(getSearchRecords);
        setSelection("Search|**|None");
        setStatus("[" + text + "] found " + getSearchRecords.length + " items.");
        setRefresh(getRefresh + 1);
    }

    const updateRecords = (selKey, e, status) => {
        setSelection(selKey);
        setRecords(e);
        setStatus(status);
        setRefresh(getRefresh + 1);
    }

    const updateFavorite = (e) => {
        var fav = getFavorite;
        if (fav[e]) {
            delete fav[e];
        }
        else {
            fav[e] = true;
        }
        setFavorite(fav);
        setRefresh(getRefresh + 1);
    }

    const clickFavoritePane = (e) => {
        var records = [];
        var keys = Object.keys(getFavorite);
        for (var i in keys) {
            records.push(keys[i]);
        }
        setRecords(records);
        setSelection("Favorite|**|None");
        setStatus("Show Favorites");
        setRefresh(getRefresh + 1);
    }

    const clickSummaryPane = (e) => {
        var records = [];
        setRecords(records);
        setSelection("Summary|**|None");
        setStatus("Show Summary");
        setRefresh(getRefresh + 1);
    }

    // *******************

    let sideItems = [];

    sideItems.push(
        <div key={sideItems.length} style={{ textAlign: 'right'}}>
            <span className="mr-1 clickable" onClick={()=>setColSize(Math.max(getColSize-1, 2))}><ArrowLeftShort/></span>
            <span className="mr-1 clickable" onClick={()=>setColSize(Math.min(getColSize+1, 5))}><ArrowRightShort/></span>
        </div>
    );

    let isSummarySelected = getSelection.startsWith("Summary|**|");
    sideItems.push(
        <div key={sideItems.length}>
            <span className="mr-1">{isSummarySelected ? <FillSquare /> : <SquareIcon />} </span>
            <span className="mr-1" onClick={clickSummaryPane}>{isSummarySelected ? (<b>Summary</b>) : (<span>Summary</span>)}</span>
        </div>
    );

    if (props.getIncludeLunr) {
        sideItems.push(
            <div onClick={clickSearchPane} key={sideItems.length}>
                <div className="mr-1" onClick={clickFavoritePane}>
                    <span className="mr-1">{getSelection.startsWith("Search|**|") ? (<b>Search</b>) : (<span>Search</span>)}</span>
                    <Badge pill={true} bg="info">Found: {getSearchRecords.length}</Badge>
                </div>
                <div className="ml-indent1">
                    <input id='searchterm' type="text" size="16" onChange={onChange} onKeyDown={onKeyDown}></input>
                </div>
            </div>
        );
    }

    let isFavoriteSelected = getSelection.startsWith("Favorite|**|");
    sideItems.push(
        <div key={sideItems.length}>
            <span className="mr-1">{isFavoriteSelected ? <FillSquare /> : <SquareIcon />} </span>
            <span className="mr-1" onClick={clickFavoritePane}>{isFavoriteSelected ? (<b>Favorite</b>) : (<span>Favorite</span>)}</span>
            <Badge pill={true} bg="secondary"><HeartFillIcon /> {Object.keys(getFavorite).length}</Badge>
        </div>
    );

    for (let n in props.Index.Index) {
        let idx = props.Index.Index[n];

        if (idx.Name.startsWith("-"))
        {
            continue;
        }

        sideItems.push(
            <IndexPane key={sideItems.length}
                Records={props.Records}
                Index2Level={idx.Index}
                Selection={getSelection}
                Favorite={getFavorite}
                onChange={updateRecords}
                Title={idx.Name}
            />
        );
    }

    // *******************

    let items = [];

    if (isSummarySelected)
    {
        items.push(
            <SummaryPage
                key={items.length}
                Index={props.Index}
                Records={getRecords}
                Status={getStatus}
            />
        )
    }
    else
    {
        items.push(
            <RecordPage
                key={items.length}
                Index={props.Index}
                Records={getRecords}
                SearchRecords={getSearchRecords}
                Favorite={getFavorite}
                Status={getStatus}
                UpdateFavorite={updateFavorite}
            />
        );
    }

    let topHeight = 30;

    return (
        <div className="container-fluid">
            <div className="row" style={{ height: topHeight + "px", borderBottomStyle: "solid", borderWidth: "1px", backgroundColor: "lightgray" }}>
                <center><b>{props.Index.File.name}</b> <small><Badge pill={true} bg="info">Records: {props.Index.Records.length}</Badge></small></center>
            </div>
            <div className="row">
                <div className={"col-" + getColSize + " scrollable"} style={{ height: (window.innerHeight - topHeight) + "px", borderRightStyle: "solid", borderWidth: "1px" }}>
                    {sideItems}
                </div>
                <div className={"col-" + (12 - getColSize)} style={{ height: (window.innerHeight - topHeight) }}>
                    {items}
                </div>
            </div>
        </div>
    );
}

export default Viewer;
